import { cssToken } from '@youhelp-ru/ui';
import { WithDefaultToastOptions } from './types';

export const TOAST_TYPES = {
  SUCCESS: 'success',
  INFO: 'info',
  ERROR: 'error',
} as const;

export const TOAST_POSITIONS = {
  TOP_RIGHT: 'top-right',
  TOP_LEFT: 'top-left',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_LEFT: 'bottom-left',
  TOP_CENTER: 'top-center',
  BOTTOM_CENTER: 'bottom-center',
} as const;

export const TOAST_ANIMATIONS = {
  SLIDE_UP: 'slide-up',
  SLIDE_DOWN: 'slide-down',
  SLIDE_LEFT: 'slide-left',
  SLIDE_RIGHT: 'slide-right',
  FADE: 'fade',
} as const;

export const DEAFULT_OPTIONS: WithDefaultToastOptions = {
  duration: 3000,
  animation: TOAST_ANIMATIONS.SLIDE_RIGHT,
  position: TOAST_POSITIONS.TOP_RIGHT,
};

export const TOAST_STEPS = {
  INIT: 'init',
  CLOSE: 'close',
} as const;

export const ToastCssTokens = {
  topOffset: cssToken('Toast', 'top'),
  bottomOffset: cssToken('Toast', 'bottom'),
} as const;
